import { render } from "./process-delete.vue?vue&type=template&id=56466ccc"
import script from "./process-delete.vue?vue&type=script&lang=js"
export * from "./process-delete.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__